module.exports = __webpack_public_path__ + "img/6_gift.a0955bc3.png";